module.exports = __webpack_public_path__ + "static/media/communication.dfac8002.svg";